import startCountdown from 'utils/startCountDown';

document.querySelectorAll('[data-flashsale-end-date]').forEach((element) => {
  startCountdown(parseInt(element.getAttribute('data-flashsale-end-date'), 10) * 1000, parseInt(element.getAttribute('data-now'), 10) * 1000, element);
});